// The native print dialog (window.print()) gives a real print preview, which is worth keeping
// wherever it actually works. Windows' "Microsoft Print to PDF" driver rotates the output 90°
// regardless of browser — that's not our markup, it's the OS's own print driver, which no CSS/JS
// on this page can reach or fix directly. Rather than replace window.print() everywhere (losing
// the preview for everyone, including users on OS/browser combinations where it works fine),
// this detects just that known-broken combination and falls back to a directly-generated PDF
// download only there.
//
// Scoped to Windows only, not also Firefox-on-any-OS: Firefox's own print dialog has separate
// bugs (Color toggle disabled, an inconsistent Pages-section) that reproduce regardless of OS,
// but macOS/Linux Firefox users still get a working, if imperfect, native preview — losing that
// preview app-wide for every Firefox user to fix a Windows-specific driver bug was a worse
// trade than leaving those two as known Firefox quirks.
export function shouldUsePdfFallback(userAgent: string = navigator.userAgent): boolean {
  return /Windows/.test(userAgent)
}
